import React from 'react';

import { Stack, TextField } from '@mui/material';
import { AsyncThunk } from '@reduxjs/toolkit';
import { EditDrawer } from 'common/components/EditDrawer';
import { ErrorHandler } from 'common/components/errorHandler/ErrorHandler';
import { getOptionLabelDefaultCallback,isOptionEqualToValueDefaultCallback } from 'common/components/sharedCustomComponents/Common/helpers';
import { EntitiesSearchableCommonDropDown } from 'common/components/sharedCustomComponents/EntitiesSearchableCommonDropDown/EntitiesSearchableCommonDropDown';

export interface MembershipLinkingDrawerContentProps<T> {
    title: string;
    processing: boolean;
    saveButtonFunction: () => void;
    entity: T | null;
    onEntityChange: (e: unknown, entity: T | null) => void;
    tenantId: string;
    tenantName: string;
    userFullName: string;
    nameInConflict: boolean;
    conflictErrorMessage: string;
    dropdownLabel: string;
    initialEntityOption: T;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    asyncThunkAction: AsyncThunk<T[], any, Record<string, unknown>>;
    displayMenuItemContent: (option: T) => React.JSX.Element;
    additionalFields?: React.ReactNode;
}

export function MembershipLinkingDrawerContent<T extends { id: string; name: string }>({
    title,
    processing,
    saveButtonFunction,
    entity,
    onEntityChange,
    tenantId,
    tenantName,
    userFullName,
    nameInConflict,
    conflictErrorMessage,
    dropdownLabel,
    initialEntityOption,
    asyncThunkAction,
    displayMenuItemContent,
    additionalFields,
}: Readonly<MembershipLinkingDrawerContentProps<T>>): React.ReactElement {
    return (
        <EditDrawer
            title={title}
            saveButtonFunction={saveButtonFunction}
            processing={processing}
        >
            <Stack spacing={2}>
                <EntitiesSearchableCommonDropDown
                    initialEntityOption={initialEntityOption}
                    value={entity}
                    onChange={onEntityChange}
                    label={dropdownLabel}
                    getOptionLabel={getOptionLabelDefaultCallback}
                    isOptionEqualToValue={isOptionEqualToValueDefaultCallback}
                    asyncThunkAction={asyncThunkAction}
                    asyncThunkArgs={{ tenantId }}
                    displayMenuItemContent={displayMenuItemContent}
                    hasError={nameInConflict}
                    effectDependecyArray={[tenantId]}
                />
                {nameInConflict &&
                    <ErrorHandler
                        errorMessage={conflictErrorMessage}
                    />
                }
                {additionalFields}
                <TextField
                    sx={{
                        backgroundColor: 'background.paper',
                        borderRadius: '4px',
                    }}
                    size="small"
                    label="Name"
                    variant="filled"
                    defaultValue={userFullName}
                    disabled
                />
                <TextField
                    sx={{
                        backgroundColor: 'background.paper',
                        borderRadius: '4px',
                    }}
                    size="small"
                    label="Tenant Name"
                    variant="filled"
                    defaultValue={tenantName}
                    disabled
                />
            </Stack>
        </EditDrawer>
    );
}
